import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';

/**
 * Assigns Drivers to a Driver Group
 * @param driverGroupId The ID of the Driver Group who the Drivers are being assigned
 * @returns Data Object containing the assigned Drivers
 */
export function postDriverGroupsDriversAssign(
  this: unknown,
  driverGroupId: number,
  assignmentIds: string[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment
          .resolve(this)
          .driverGroupsDriversAssignUrl(String(driverGroupId)),
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify({
            driverIds: assignmentIds,
          }),
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        message: z.string(),
        data: z.object({
          driverIds: z.array(z.string()),
        }),
      })
    )
  );
}
